// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "styles" + "." + "3cf5c3f431b469cda38b" + ".bundle.css";
};